import React, { forwardRef } from 'react';
import Echart from './Echart';
//const Echart = React.lazy(() => import('./Echart'));

export const EchartsCore = (charts) => forwardRef((props, ref) => <Echart charts={charts} props={props} ref={ref} />);
